import {
  type ProposalsConfig,
  ViewType,
} from '@/types/schema/page-configs/proposals'

export const defaultProposalsConfig: ProposalsConfig = {
  viewType: ViewType.Standard,
  identifierPreference: 'CUSIP',
}

export enum ProposalTableType {
  Accounts = 'accounts',
  Orders = 'orders',
}
